/**
 * Havas CX — JavaScript Entry Point
 *
 * CX-specific JS. The shared parent (main.js) is loaded separately.
 */

import initGradientBlob from '../../../../havas-global-v2/front/src/scripts/blocks/gradient-blob.js';

document.addEventListener('DOMContentLoaded', function () {
    // CX-specific blocks
    initGradientBlob({
        blockSelector: '.cx-block-bg--gradient',
        blobSelector: '.cx-gradient-blob--block',
        staticClass: 'cx-gradient-blob--static',
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('havas-cx-theme');

    // Move hero content into main__flexibles on mobile
    const heroContent = document.querySelector('.f-herohome-cx__content');
    const mainFlexibles = document.getElementById('maincontent');
    const heroBox = document.querySelector('.f-herohome-cx');
    const MOBILE_BREAKPOINT = 840;

    if (heroContent && mainFlexibles && heroBox) {
        function handleResize() {
            if (window.innerWidth <= MOBILE_BREAKPOINT) {
                // Move content to top of main__flexibles
                if (heroContent.parentNode !== mainFlexibles) {
                    mainFlexibles.insertBefore(heroContent, mainFlexibles.firstChild);
                }
            } else {
                // Move content back into hero
                if (heroContent.parentNode !== heroBox) {
                    heroBox.appendChild(heroContent);
                }
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
    }
});